import {Col, Container, Dropdown, Row} from 'react-bootstrap';
import TrackingCard from './components/TrackingCard';
import {useAppDispatch} from '../../hooks/hooks';
import {useEffect, useState} from 'react';
import {setLoading} from '../../store/userSlice';
import {getTrackingsList} from './Initiatives.service';
import ItemsPagination from '../../UI/pagination/ItemsPagination';
import {TrackingType} from './interfaces/ITrackings';
import classes from './style/List.module.css'
import { CheckBoxTitle } from '../../UI/check-box-title/CheckBoxTitle';
import SearchButton from '../../components/search-button/SearchButton';
import { useNavigate } from 'react-router-dom';

const FollowUpType = [
  {id: 'multi', name: 'package'},
  {id: 'single', name: 'single'},
];

const languages = [
  {id: 'ar', name: 'Arabic'},
  {id: 'en', name: 'English'},
];

const Provider = [
  {id: 'admin', name: 'Nualim'},
  {id: 'consultant', name: 'Consultants'},
];

const Price = [
  {id: 'free', name: 'Free'},
  {id: 'paid', name: 'Paid'},
];

const UserInitiativesList = () => {
  const dispatch = useAppDispatch();

  const [trackings, setTrackings] = useState([]);
  const [lastPage, SetLastPage] = useState<number>(1);
  const [page, setPage] = useState<number>(1);
  const [title, setTitle] = useState<string>('');
  const [languagesSelected, setLanguagesSelected] = useState<any>([]);
  const [followUpTypeSelected, setFollowUpTypeSelected] = useState<any>([]);
  const [providerSelected, setProviderSelected] = useState<any>([]);
  const [priceSelected, setPriceSelected] = useState<any>([]);
  const [getFromRedirect, setGetFromRedirect] = useState<boolean>(true);
  
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [page]);

  const getData = async () => {
    //setPage(page)
    
    dispatch(setLoading(true));
    let result = await getTrackingsList(
      page,
      title,
      languagesSelected,
      followUpTypeSelected,
      providerSelected,
      priceSelected
      );
    if (result.response) {
      
      setTrackings(result.response.data.data);
      SetLastPage(result.response.data.page_meta.last_page);
      if( result.response.data.data.length == 0 && getFromRedirect ){
        navigate(`?tab=discoverTrackingSystems`);
        setGetFromRedirect(false)
      }
      
      
      
    }
    dispatch(setLoading(false));
    
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      getData()
    }
  };

  const getLangVal = (value:any) => {
    setPage(1)
    let sourceArr = languagesSelected
    if (languagesSelected?.includes(value)) {
      let index = sourceArr.indexOf(value);
      sourceArr.splice(index, 1);
      setLanguagesSelected(sourceArr);
    } else {
      sourceArr.push(value)
      setLanguagesSelected(sourceArr);
    }
    console.log('languagesSelected', languagesSelected)
    getData()
    
  }

  const getFollowUpTypeVal = (value:any) => {
    setPage(1)
    let sourceArr = followUpTypeSelected
    if (followUpTypeSelected?.includes(value)) {
      let index = sourceArr.indexOf(value);
      sourceArr.splice(index, 1);
      setFollowUpTypeSelected(sourceArr);
    } else {
      sourceArr.push(value)
      setFollowUpTypeSelected(sourceArr);
    }
    console.log('followUpTypeSelected', followUpTypeSelected)
    getData()
    
  }

  const getProviderVal = (value:any) => {
    setPage(1)
    let sourceArr = providerSelected
    if (providerSelected?.includes(value)) {
      let index = sourceArr.indexOf(value);
      sourceArr.splice(index, 1);
      setProviderSelected(sourceArr);
    } else {
      sourceArr.push(value)
      setProviderSelected(sourceArr);
    }
    console.log('providerSelected', providerSelected)
    getData()
    
  }

  const getPriceVal = (value:any) => {
    setPage(1)
    let sourceArr = priceSelected
    if (priceSelected?.includes(value)) {
      let index = sourceArr.indexOf(value);
      sourceArr.splice(index, 1);
      setPriceSelected(sourceArr);
    } else {
      sourceArr.push(value)
      setPriceSelected(sourceArr);
    }
    console.log('priceSelected', priceSelected)
    getData()
    
  }

 

 

  return (
    <div>
      
      
      
        <Row>
          

        {trackings.map((tracking: TrackingType) => {
          return (
            <Col lg={4} className='card-item-container'>
                    <TrackingCard
                      tracking={tracking}
                      isPackage={tracking.tracking_type == 'multi'}
                      enrolled={true}
                    />
                  </Col>
                );
              })}
              {trackings.length ?
              <Col lg={12}>
            <div className="pagination-container">
              <ItemsPagination
                pages={lastPage}
                current={page}
                changePage={page => {
                  setPage(page);
                }}
              />
            </div>
            </Col>
            :
            ''
            }

            {trackings.length == 0
            ?
            <div className='text-center'>
              <img src="/logo.png" alt="img" width={70} />
              <h3 className="text-center mt-3">Sorry, there is no data found.</h3>
            </div>
            :
            ''
            }

              </Row>
            
            
          

          
    </div>
  );
};

export default UserInitiativesList;
